<form [formGroup]="formGroup" id="step2Form">
  <div class="step2-form-container">
    <div class="row">
      <div
        *ngIf="controls.telephoneNumber as telephoneNumber"
        class="standard-form-field widened-field telephoneNumber-field required-field">
        <label for="telephoneNumberInput" [class.invalid]="telephoneNumber.touched && telephoneNumber.invalid">
          {{ 'PERSONAL_DATA_FORM.TELEPHONE-NUMBER.INFIELD-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            #telephoneNumberInput
            id="telephoneNumberInput"
            placeholder="{{ 'PERSONAL_DATA_FORM.TELEPHONE-NUMBER.PLACEHOLDER' | translate }}"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="telephoneNumber.touched && telephoneNumber.invalid ? 'true' : null"
            [attr.aria-describedby]="telephoneNumber.touched && telephoneNumber.invalid ? 'telephoneNumberError' : null"
            (keydown)="firstInputKeydown($event)"
            formControlName="telephoneNumber" />

          <!-- ERROR -->
          <mat-error *ngIf="telephoneNumber.touched && telephoneNumber.invalid" id="telephoneNumberError">
            {{ telephoneNumber.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div
        *ngIf="controls.profession as profession"
        class="standard-form-field widened-field profession-field required-field">
        <label id="applicantProfessionLabel" [class.invalid]="profession.touched && profession.invalid">
          {{ 'PERSONAL_DATA_FORM.PROFESSION.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <mat-select
            [formControl]="profession"
            id="applicantProfession"
            aria-labelledby="applicantProfessionLabel"
            panelClass="standard-select"
            placeholder="{{ 'PERSONAL_DATA_FORM.PROFESSION.PLACEHOLDER' | translate }}"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="profession.touched && profession.invalid ? 'true' : null"
            [attr.aria-describedby]="profession.touched && profession.invalid ? 'professionError' : null">
            <mat-option *ngFor="let item of professions" [value]="item">
              {{ 'COMMON.PROFESSIONS.' + item | translate }}
            </mat-option>
          </mat-select>

          <!-- ERROR -->
          <mat-error *ngIf="profession.touched && profession.invalid" id="professionError">
            {{ profession.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="nowrap-container">
        <div
          *ngIf="controls.descriptionHeight as descriptionHeight"
          class="standard-form-field descriptionHeight-field required-field">
          <label
            for="applicantDescriptionHeight"
            [class.invalid]="descriptionHeight.touched && descriptionHeight.invalid">
            {{ 'PERSONAL_DATA_FORM.DESCRIPTION-HEIGHT.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantDescriptionHeight"
              type="number"
              min="50"
              max="280"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="descriptionHeight.touched && descriptionHeight.invalid ? 'true' : null"
              [attr.aria-describedby]="
                descriptionHeight.touched && descriptionHeight.invalid ? 'descriptionHeightError' : null
              "
              placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-HEIGHT.PLACEHOLDER' | translate }}"
              [formControl]="descriptionHeight" />

            <!-- ERROR -->
            <mat-error *ngIf="descriptionHeight.touched && descriptionHeight.invalid" id="descriptionHeightError">
              {{ descriptionHeight.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.descriptionColourOfEyes as descriptionColourOfEyes"
          class="standard-form-field descriptionColourOfEyes-field required-field">
          <label
            id="applicantDescriptionColourOfEyesLabel"
            [class.invalid]="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid">
            {{ 'PERSONAL_DATA_FORM.DESCRIPTION-COLOUR-OF-EYES.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              [formControl]="descriptionColourOfEyes"
              id="applicantDescriptionColourOfEyes"
              aria-labelledby="applicantDescriptionColourOfEyesLabel"
              panelClass="standard-select"
              placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-COLOUR-OF-EYES.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid ? 'true' : null"
              [attr.aria-describedby]="
                descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid
                  ? 'descriptionColourOfEyesError'
                  : null
              ">
              <mat-option *ngFor="let item of selectsValues.EYES" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error
              *ngIf="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid"
              id="descriptionColourOfEyesError">
              {{ descriptionColourOfEyes.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        *ngIf="controls.descriptionSpecialMarks as descriptionSpecialMarks"
        class="standard-form-field widened-field descriptionSpecialMarks-field">
        <label
          for="applicantDescriptionSpecialMarks"
          [class.invalid]="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid">
          {{ 'PERSONAL_DATA_FORM.DESCRIPTION-SPECIAL-MARKS.MAIN-LABEL' | translate }}
        </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="applicantDescriptionSpecialMarks"
            type="text"
            maxLength="200"
            minLength="1"
            placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-SPECIAL-MARKS.PLACEHOLDER' | translate }}"
            [required]="false"
            [attr.aria-required]="false"
            [attr.aria-invalid]="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid ? 'true' : null"
            [attr.aria-describedby]="
              descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid ? 'descriptionSpecialMarksError' : null
            "
            [formControl]="descriptionSpecialMarks" />

          <!-- ERROR -->
          <mat-error
            *ngIf="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid"
            id="descriptionSpecialMarksError">
            {{ descriptionSpecialMarks.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <nz-divider [nzText]="adresses" nzOrientation="center">
      <ng-template #adresses>
        <h5>{{ 'PERSONAL_DATA_FORM.PLACE_OF_STAY' | translate }}</h5>
      </ng-template>
    </nz-divider>
    <div class="row">
      <div class="nowrap-container">
        <div
          *ngIf="controls.residenceStreet as residenceStreet"
          class="standard-form-field residenceStreet-field required-field">
          <label for="applicantResidenceStreet" [class.invalid]="residenceStreet.touched && residenceStreet.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantResidenceStreet"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="residenceStreet.touched && residenceStreet.invalid ? 'true' : null"
              [attr.aria-describedby]="
                residenceStreet.touched && residenceStreet.invalid
                  ? 'residenceStreetError residenceStreetTooltip'
                  : 'residenceStreetTooltip'
              "
              [formControl]="residenceStreet" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'residenceStreetTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="residenceStreet.touched && residenceStreet.invalid" id="residenceStreetError">
              {{ residenceStreet.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.residenceHouseNumber as residenceHouseNumber"
          class="standard-form-field residenceHouseNumber-field required-field">
          <label
            for="applicantResidenceHouseNumber"
            [class.invalid]="residenceHouseNumber.touched && residenceHouseNumber.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantResidenceHouseNumber"
              type="text"
              maxLength="20"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="residenceHouseNumber.touched && residenceHouseNumber.invalid ? 'true' : null"
              [attr.aria-describedby]="
                residenceHouseNumber.touched && residenceHouseNumber.invalid
                  ? 'residenceHouseNumberError residenceHouseNumberTooltip'
                  : 'residenceHouseNumberTooltip'
              "
              [formControl]="residenceHouseNumber" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'residenceHouseNumberTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error
              *ngIf="residenceHouseNumber.touched && residenceHouseNumber.invalid"
              id="residenceHouseNumberError">
              {{ residenceHouseNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="nowrap-container">
        <div
          *ngIf="controls.residenceApartmentNumber as residenceApartmentNumber"
          class="standard-form-field residenceApartmentNumber-field">
          <label
            for="applicantResidenceApartmentNumber"
            [class.invalid]="residenceApartmentNumber.touched && residenceApartmentNumber.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantResidenceApartmentNumber"
              type="text"
              maxLength="20"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="residenceApartmentNumber.touched && residenceApartmentNumber.invalid ? 'true' : null"
              [attr.aria-describedby]="
                residenceApartmentNumber.touched && residenceApartmentNumber.invalid
                  ? 'residenceApartmentNumberError residenceApartmentNumberTooltip'
                  : 'residenceApartmentNumberTooltip'
              "
              [formControl]="residenceApartmentNumber" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'residenceApartmentNumberTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error
              *ngIf="residenceApartmentNumber.touched && residenceApartmentNumber.invalid"
              id="residenceApartmentNumberError">
              {{ residenceApartmentNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="additional-border" [class.border-enabled]="mode === 'employee'">
      <div class="row extra-margin">
        <div class="nowrap-container">
          <div
            *ngIf="controls.residenceCity as residenceCity"
            class="standard-form-field residenceCity-field required-field">
            <label for="applicantResidenceCity" [class.invalid]="residenceCity.touched && residenceCity.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="applicantResidenceCity"
                type="text"
                maxLength="200"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="residenceCity.touched && residenceCity.invalid ? 'true' : null"
                [attr.aria-describedby]="residenceCity.touched && residenceCity.invalid ? 'residenceCityError' : null"
                [formControl]="residenceCity" />

              <!-- ERROR -->
              <mat-error *ngIf="residenceCity.touched && residenceCity.invalid" id="residenceCityError">
                {{ residenceCity.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.residencePostalCode as residencePostalCode"
            class="standard-form-field residencePostalCode-field required-field">
            <label
              for="applicantResidencePostalCode"
              [class.invalid]="residencePostalCode.touched && residencePostalCode.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="applicantResidencePostalCode"
                type="text"
                maxLength="6"
                minLength="6"
                [mask]="'99-999'"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="residencePostalCode.touched && residencePostalCode.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  residencePostalCode.touched && residencePostalCode.invalid ? 'residencePostalCodeError' : null
                "
                [formControl]="residencePostalCode" />

              <!-- ERROR -->
              <mat-error
                *ngIf="residencePostalCode.touched && residencePostalCode.invalid"
                id="residencePostalCodeError">
                {{ residencePostalCode.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="nowrap-container">
          <div
            *ngIf="controls.residenceVoivodeshipDetailsId as residenceVoivodeshipDetailsId"
            class="standard-form-field residenceVoivodeshipName-field required-field">
            <label
              id="applicantResidenceVoivodeshipNameLabel"
              [class.invalid]="residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-VOIVODESHIP-NAME.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" *ngIf="voivodeships$ | async as voivodeships">
              <mat-select
                [formControl]="residenceVoivodeshipDetailsId"
                id="applicantResidenceVoivodeshipName"
                aria-labelledby="applicantResidenceVoivodeshipNameLabel"
                panelClass="['standard-select', longer-select']"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-VOIVODESHIP-NAME.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid
                    ? 'residenceVoivodeshipDetailsIdError'
                    : null
                ">
                <mat-option *ngFor="let voivo of voivodeships" [value]="voivo.id">
                  {{ 'COMMON.VOIVODESHIPS.' + voivo.key | translate }}
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error
                *ngIf="residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid"
                id="residenceVoivodeshipDetailsIdError">
                {{ residenceVoivodeshipDetailsId.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="lookingForVoivodeship" class="loading-wrapper" role="status" aria-live="polite">
            <span class="sr-only">
              {{ 'COMMON.LAYOUT.LOADING' | translate }}
            </span>

            <mat-spinner [diameter]="50" [attr.aria-hidden]="true"> </mat-spinner>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="mode === 'employee'">
        <div
          *ngIf="controls.residenceDistrictId as residenceDistrictId"
          class="standard-form-field residenceDistrict-field">
          <label
            id="applicantResidenceDistrictIdLabel"
            [class.invalid]="residenceDistrictId.touched && residenceDistrictId.invalid">
            {{ 'COMMON.LABEL.DISTRICT' | translate }}
          </label>
          <mat-form-field appearance="outline" *ngIf="districts$ | async as districts">
            <mat-select
              [formControl]="residenceDistrictId"
              [disabled]="!controls.residenceVoivodeshipDetailsId?.value"
              id="applicantResidenceDistrictId"
              aria-labelledby="applicantResidenceDistrictIdLabel"
              [panelClass]="['standard-select', 'longer-select']"
              appMatOptionHeight
              [appMatOptionHeightValue]="50"
              [attr.aria-required]="false"
              [attr.aria-invalid]="residenceDistrictId.touched && residenceDistrictId.invalid ? 'true' : null"
              [attr.aria-describedby]="
                residenceDistrictId.touched && residenceDistrictId.invalid ? 'residenceDistrictIdError' : null
              "
              class="heightened-select">
              <mat-option *ngIf="loadingDistricts$ | async" role="status" aria-live="polite">
                <span class="sr-only">
                  {{ 'COMMON.LAYOUT.LOADING' | translate }}
                </span>

                <mat-spinner [diameter]="25" [attr.aria-hidden]="true"> </mat-spinner>
              </mat-option>

              <mat-option *ngFor="let district of districts" [value]="district.id">
                {{ district.MOS_name.toUpperCase() }} ({{ district.MOS_extra_name.toUpperCase() }})
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error *ngIf="residenceDistrictId.touched && residenceDistrictId.invalid" id="residenceDistrictIdError">
              {{ residenceDistrictId.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.residenceMunicipalityId as residenceMunicipalityId"
          class="standard-form-field residenceMunicipality-field">
          <label
            id="applicantResidenceMunicipalityIdLabel"
            [class.invalid]="residenceMunicipalityId.touched && residenceMunicipalityId.invalid">
            {{ 'COMMON.LABEL.MUNICIPALITY' | translate }}
          </label>
          <mat-form-field appearance="outline" *ngIf="municips$ | async as municips">
            <mat-select
              [formControl]="residenceMunicipalityId"
              [disabled]="!controls.residenceDistrictId?.value"
              id="applicantResidenceMunicipalityId"
              aria-labelledby="applicantResidenceMunicipalityIdLabel"
              [panelClass]="['standard-select', 'longer-select']"
              appMatOptionHeight
              [appMatOptionHeightValue]="50"
              [attr.aria-required]="false"
              [attr.aria-invalid]="residenceMunicipalityId.touched && residenceMunicipalityId.invalid ? 'true' : null"
              [attr.aria-describedby]="
                residenceMunicipalityId.touched && residenceMunicipalityId.invalid
                  ? 'residenceMunicipalityIdError'
                  : null
              ">
              <mat-option *ngIf="loadingMunicips$ | async" role="status" aria-live="polite">
                <span class="sr-only">
                  {{ 'COMMON.LAYOUT.LOADING' | translate }}
                </span>

                <mat-spinner [diameter]="25" role="status" [attr.aria-hidden]="true"> </mat-spinner>
              </mat-option>

              <mat-option *ngFor="let municip of municips" [value]="municip.id">
                {{ municip.MOS_name.toUpperCase() }} ({{ municip.MOS_type.toUpperCase() }})
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error
              *ngIf="residenceMunicipalityId.touched && residenceMunicipalityId.invalid"
              id="residenceMunicipalityIdError">
              {{ residenceMunicipalityId.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.residenceCityListedId as residenceCityListedId"
          class="standard-form-field residenceCityListed-field">
          <label
            id="applicantResidenceCityListedIdLabel"
            [class.invalid]="residenceCityListedId.touched && residenceCityListedId.invalid">
            {{ 'COMMON.LABEL.CITY_MOS' | translate }}
          </label>
          <mat-form-field appearance="outline" *ngIf="cities$ | async as cities">
            <mat-select
              [formControl]="residenceCityListedId"
              [disabled]="!controls.residenceMunicipalityId?.value"
              id="applicantResidenceCityListedId"
              aria-labelledby="applicantResidenceCityListedIdLabel"
              [panelClass]="['standard-select', 'longer-select']"
              (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()"
              appMatOptionHeight
              [appMatOptionHeightValue]="50"
              [attr.aria-required]="false"
              [attr.aria-invalid]="residenceCityListedId.touched && residenceCityListedId.invalid ? 'true' : null"
              [attr.aria-describedby]="
                residenceCityListedId.touched && residenceCityListedId.invalid ? 'residenceCityListedIdError' : null
              ">
              <mat-option *ngIf="loadingCities$ | async" role="status" aria-live="polite">
                <span class="sr-only">
                  {{ 'COMMON.LAYOUT.LOADING' | translate }}
                </span>

                <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
              </mat-option>

              <mat-option *ngFor="let city of cities" [value]="city.id">
                {{ city.MOS_name.toUpperCase() }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error
              *ngIf="residenceCityListedId.touched && residenceCityListedId.invalid"
              id="residenceCityListedIdError">
              {{ residenceCityListedId.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="zip-warning-overflow-container" *ngIf="voivoIsBeeingUsed && !userACKDocumentsReset">
        <h4 class="mat-h4">{{ 'PERSONAL_DATA_FORM.IF_YOU_CHANGE_VOIVO_DOCUMENTS_RESET' | translate }}</h4>
        <button mat-raised-button color="primary" (click)="voivoChangeACK()">
          {{ 'APPLICATION.I_UNDERSTAND_AND_WANT_TO_PROCEED' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>
